<li *scRichText="rendering.fields.name"></li>
